export default __webpack_public_path__ + "locales/it/DeleteDialog.json?hash=1f202747c2126275b264e382630091d5";